export const flux = {
  audit: 'Audit',
  attribution: 'Attribution',
  signer: 'Signer',
  comment: {
    title: 'Commentaire du lot {{batchId}}',
    columns: {
      date: 'Date',
      comment: 'Commentaire',
      type: 'Type',
      login: 'Login',
    },
    add: 'Ajouter un commentaire',
  },
  validate: 'Valider le contrôle',
  relaunch: 'Relancer le fraud monitor',
  print: 'Imprimer',
  send: 'Envoyer',
  slip: 'Bordereau',
  edit: 'Etes-vous sûr de vouloir éditer les opérations de ce lot et le remettre en saisie',
  remettre: 'Remettre en Saisie',
  visualiserPDF: 'Justificatif',
  unauthorize_view:
    "La visualisation du détail n'est pas autorisée sur ce type de flux",
  detail: {
    title: {
      remittance: 'Détail de la remise {{remittance_number}}',
      facture: 'Détail des facture {{remittance_number}}',
      operation: 'Opération',
    },
    columns: {
      beneficiary_name: 'Bénéficiaire',
      reference_label: 'Référence/Libellé',
      print: 'Visualiser',
      number: 'N°',
      amount: 'Montant',
      currency: 'Devise',
      ara: 'ARA',
      reject: 'Rejet',
      rules: 'Règles',
      fraud_monitor: 'Fraud monitor',
      choice: 'Choix',
      delete: 'Suppression',
      vsr: 'Statut VSR',
    },
    buttons: {
      tracking: 'Tracker',
      invoice: 'Factures',
      print: 'Imprimer Avis',
      back: 'Retour',
      validate: 'Confirmer le contrôle',
      validateChoice: 'Valider le choix',
      refuse: 'Rejeter le lot',
    },
    champ_titles: {
      societe: 'Société',
      compte: 'Compte',
      ibanBban: 'IBAN/BBAN',
      lot_number: 'N° Lot',
      origine: 'Origine',
      author: 'Login',
      state: 'Etat',
      flow: 'Flux',
      creation_date: 'Création le',
      execution_date: 'Exécution le',
      emitter: 'Emetteur',
      operation_number: 'Nb',
      amount: 'Montant remise',
      status: 'Statut',
      reason: 'Motif',
      label: 'Libelle',
      origin_amount: 'Montant Origine',
      fee: 'Frais',
      fee_type: 'Type de frais',
      tracker_number: 'N° tracker',
      confirmation_date: 'Date confirmée',
      amount_credited: 'Montant Crédité',
      send: 'Envoyé le',
    },
    tracking_status: {
      ACSC: "Confirmation de débit, preuve de l'initiation du paiement.",
      G001: "Règlement en cours. Paiement transféré à un agent non gpi ou à un MI (système d'échange interbancaire local) non pris en charge.",
      G005: 'Règlement en cours. Livré à la banque bénéficiaire en tant que gpi.',
      G006: 'Règlement en cours. Livré à la banque bénéficiaire en tant que non gpi.',
      Gxxx: 'Règlement en cours.',
      ACCC: 'Le créancier a été crédité.',
      RJCT: 'Rejeté',
      PDNG: 'En cours',
    },
    process: {
      treated: 'Traité',
      waiting: 'En attente',
      credited: 'Crédité',
    },
    copy: 'Copier le lien.',
    copied: 'Copié !',
    coller: 'Coller !',
    invoice: {
      champ_titles: {
        IBAN: 'IBAN',
        ibanBban: 'IBAN/BBAN',
        reference: 'Référence',
        label: 'Libellé',
        montant: 'Montant',
        devise: 'Devise',
        tiers: 'Tiers',
      },
      columns: {
        client_reference: 'Référence Client',
        supplier_reference: 'Référence Fournisseur',
        invoice_number: 'N° Facture',
        date_fact: 'Date Facture',
      },
    },
  },
  ModalSendMessage: {
    title: 'Envoi email',
    template_email: 'Template email',
    email: 'email',
  },

  EditRemise: 'Modification de la date d’exécution de la remise {{id}}',
  EditRemiseMultiple: 'Modification de la date d’exécution des remises',
  operation: 'Editer les opérations',
  FraudMonitor: {
    fiche: {},
    table: {
      title: 'Liste des lots en contrôle',
      buttons: {
        audit: 'Audit',
        validate: 'Valider le contrôle',
        print: 'Imprimer',
      },
      columns: {
        batche_number: 'N° lot',
        remittance_number: 'N° remise',
        flow: 'Flux',
        state: 'Etat',
        transmitter: 'Compte',
        login: 'Login',
        date: 'Date',
        operation_number: 'Nb',
        amount: 'Montant',
        currency: 'Devise',
        origin: 'Origine',
        status: 'Statut',
      },
      modal: {
        title: {
          audit: 'Audit du lot n° {{batche_number}}',
        },
        columns: {
          date: 'Date',
          login: 'Login',
          action: 'Action',
        },
        buttons: {
          buttons: 'Fermer',
        },
      },
    },
  },
  Cheque: {
    fiche: {},
    table: {
      title: 'Liste des lots de chèques à imprimer',
      // buttons: {
      //   audit: 'Audit',
      //   validate: 'Valider le contrôle',
      //   print: 'Imprimer',
      // },
      columns: {
        batche_number: 'N° lot',
        remittance_number: 'N° remise',
        flow: 'Flux',
        state: 'Etat',
        transmitter: 'Compte',
        login: 'Login',
        date: 'Date',
        operation_number: 'Nb',
        amount: 'Montant',
        currency: 'Devise',
        origin: 'Origine',
        status: 'Statut',
        check_print: 'Imprimer chèques',
      },
      apercu: {
        title: 'Apercu des chèques à imprimer',
        button: 'Valider impression',
      },
      range: {
        title: 'Plage de numéro chèques',
        next: 'Prochain numéro',
        last: 'Dernier numéro',
        first_op: 'N° première opération',
        last_op: 'N° dernière opération',
        account_divider: 'Paramétrage de compte',
        update: 'Modifier la plage de chèque',
        error:
          'La plage saisie est supérieure à la plage autorisée.\nVeillez augmenter la plage de votre compte.',
        button: 'Plage',
      },
      modal: {
        title: {
          audit: 'Audit du lot n° {{batche_number}}',
        },
        columns: {
          date: 'Date',
          login: 'Login',
          action: 'Action',
        },
        buttons: {
          buttons: 'Fermer',
        },
      },
      message:
        'Avez-vous bien imprimé le(s) chèque(s) ? Après validation vous ne pourez plus imprimer le(s) chèque(s).',
    },
  },
  Integration: {
    table: {
      title: 'Import manuel de fichiers',
      addfile: 'Ajouter',
      labelmodel: "Modèle d'import",
      choosefile: 'Sélection de fichiers',
      import_placeholder: 'Aucun',
      smartag: 'SmartTags',
    },
  },
  GestionLots: {
    header: {
      title: 'Gestion des lots',
    },
    columns: {
      flow: 'Flux',
      state: 'Etat',
      account: 'Compte',
      login: 'Login',
      date: 'Date',
      count: 'Nb opérations',
      montant: 'Montant',
      devise: 'Devise',
      origin: 'Origine',
      status: 'Statut',
      pdf_files: 'PDF',
      comment: 'Com.',
      signing: 'Signature',
      lot_number: 'N° lot',
      remittance_number: 'N° remise',
      amount_max: 'Max',
      amount_min: 'Min',
      smarttag: 'SmartTags',
      source_file_name: 'Nom du fichier',
      date_transmission: 'Date Transmission',
    },
    modal: {
      title: 'Détails de la remise {{remittance_num}}',
      audit: 'Audit du lot n° {{batche_number}}',
      titleDelete: 'Commentaire pour suppression du lot n° {{batche_number}}',
      buttonDelete: 'Supprimer',
    },
    attributionModal: {
      message_infos_type_pdf: 'Seuls les fichiers PDF sont autorisés',
      title: 'Attribution des signataires du lot n° {{num_attribution}}',
      title_document_validation: 'Attribution des signataires',
      state_signature: 'Etat signature',
      flux: 'Flux',
      created_date: 'Date de création',
      operationNumber: "Nb d'opération",
      amount: 'Montant',
      currency: 'Devise',
      name: 'Nom',
      one_signature: 'Signature 1',
      college: 'Collège',
      niveau: 'Niveaux',
      two_signature: 'Signature 2',
      justificated_piece: 'Pièce justificative',
      attributed: 'Attribuer',
      alert_file: 'Vous ne pouvez sélectionner que 3 fichiers au maximum.',
      columns: {
        level: 'Niveau',
        signataire1: 'Signataire 1',
        signataire2: 'Signataire 2',
        signataire: 'Signataire {{nb}}',
        college1: 'Collège 1',
        college2: 'Collège 2',
      },
    },
  },
  HistoriqueLots: {
    actions: {
      writing_generate: 'Génération des écritures comptables',
      message: 'Voulez-vous renvoyer le lot à la banque ',
    },
    header: {
      title: 'Historique des lots',
      advance_search_button: 'Recherche avancée',
      launch_search: 'Lancer la recherche',
      recherche_suppl: '- Recherche spécifiques -',
      advanced_title: 'Recherche avancée sur les opérations',
      search: 'Recherche des lots par tiers, motif, référence ...',
      transmission_date: 'Date Envoi',
      exec_date: 'Date Exécution',
      recherche_signature: '- Signataires -',
    },
    columns: {
      pdf_files: 'PDF',
      lot_number: 'N° lot',
      remise_number: 'N° remise',
      flow: 'Flux',
      state: 'Etat',
      emetteur: 'Compte',
      login: 'Login',
      date: 'Date',
      operation_number: 'Nb',
      montant: 'Montant',
      devise: 'Devise',
      origine: 'Origine',
      status: 'Statut',
      ack: 'ACK',
      delivrance: 'Délivrance',
      psr: 'PSR protocolaire',
      ara1: 'ARA 1',
      transaction_ref: 'Référence de transaction',
      account_number: 'N° compte',
      third_party: 'Tiers',
      montant_lot: 'Montant lot',
      code_countrie: 'Code pays',
      ara_operation: 'ARA Opération',
      valid_1: 'Valideur 1',
      valid_2: 'Valideur 2',
      sign_1: 'Signataire 1',
      sign_2: 'Signataire 2',
    },
  },
  Intégration: {
    fiche: {},
    table: {},
  },
  Signature: {
    header: {
      title: 'Mon parapheur de signature',
    },
    fiche: {},
    table: {
      sign: 'Signer',
      reject: 'Refuser',
    },
    modal: {
      commentTitle: 'Commentaire pour le refus du lot {{name}}',
      refusTitle: 'Refuser',
      titleOTP: 'Signature OTP',
      titleEbics: 'Signature Ebics TS',
      sendOTP: 'Signer le lot',
      sendEbics: 'Signer électroniquement',
      cancel: 'Annuler',
      champOTP: 'Saisir le code reçu par SMS ou le code à usage unique',
      champEbics: 'Saisir le mot de passe de la clé',
      validate: 'Valider la signature',
      decline: 'Refuser',
      comment: 'Commentaire',
      message_confirm_signin: 'Voulez-vous signer ce lot',
      lot_selec: 'Nombre de lots :  ',
      total: 'Somme arithmétique : ',
      mobile_action:
        'Avez-vous validé la signature dans votre application mobile Swift "Digital ID" ?',
      verif_code:
        'Veuillez confirmer le code de vérification suivant dans votre application mobile :',
    },
  },
  Saisie: {
    fiche: {
      title: {
        new_title: 'Nouveau lot de {{code}}',
        edit_title: 'Modification du lot n° {{id}} de {{code}}',
        operation: 'Liste des opérations',
        timeline: 'Sélection date Echéance',
      },
      champ_titles: {
        account: 'Compte émetteur',
        currency: 'Devise des opérations',
        execution_date: "Date d'exécution",
      },
      buttons: {
        save: 'Créer le lot',
        back: 'Annuler',
        send_to_validate: 'Envoyer en validation',
        timeline: 'Échéancier',
        by_list: 'Saisie par liste',
      },
      columns: {
        thirdparty: 'Tiers',
        account: 'N° compte',
        amount: 'Montant',
        currency: 'Devise',
        reference: 'Référence',
      },
      modal: {
        title: 'Saisie par liste',
        columns: {
          code: 'Code',
          name: 'Nom',
          account: 'N° compte',
          amount: 'Montant',
          currency: 'Devise',
        },
        champ_titles: {
          reference: 'Référence commune',
          reason: 'Motif commun',
        },
      },
    },
    table: {
      title: 'Liste des lots en cours de saisie',
      columns: {
        batch_number: 'N° lot',
        flow: 'Flux',
        account: 'Compte',
        operation_number: 'Nb',
        amount: 'Montant',
        currency: 'Devise',
        execution_date: 'Date exécution',
        creation_date: 'Date de création',
        update_date: 'Date de modification',
      },
      buttons: {
        new: 'Nouveau Lot',
        delete: 'Confirmez-vous la suppression',
      },
    },
    timeline: {
      title: {
        general: 'Liste des échéanciers',
        operations_list: 'Liste des opérations',
      },
      columns: {
        rum: 'RUM',
        debtor_code: 'Code débiteur',
        debtor_name: 'Nom du débiteur',
        next_due_date: 'Prochaine échéance',
        type: 'Type',
        sequence: 'Séquence',
        reason: 'Motif',
        reference: 'Référence',
        amount: 'Montant',
      },
      champ_titles: {
        date: 'Date de règlement',
        sample_number: 'Nombre du prélèvement du portefeuille',
        amount: 'Somme du portefeuille',
        reason: 'Motif',
        reference: 'Référence',
      },
      buttons: {
        addTo: 'Ajouter au lot',
        validate: 'Valider',
      },
    },
    operation: {
      title: {
        new_title: "Ajout d'une opération",
        edit_title: 'Opération {{name}}',
        address_thirdparty: 'Adresse du tiers',
        informations: 'Informations complémentaires',
        bank: 'Coordonnées bancaires',
        intermediary_bank: 'Banque intermédiaire',
        fournisseur_bank: 'Adresse fournisseur',
        fournisseur_structure_bank: 'Adresse structurée fournisseur',
      },
      champ_titles: {
        reference: 'Référence',
        amount: 'Montant',
        name: 'Nom',
        reason: 'Motif',
        country: 'Pays',
        account_number: 'N° de compte',
        bank_name: 'Domiciliation',
        bic: 'BIC',
        address: 'Adresse',
        clearing: 'Clearing',
        clearing_id: 'Clearing code / Bank code',
        type: 'Type',
      },
      buttons: {
        save: 'Valider',
        back: 'Annuler',
        search: 'Rechercher',
        import_amount: 'Charger les montants',
        excel_export: 'Export Excel',
      },
      placeholder: {
        search: "Recherche d'un tiers par code, nom, IBAN",
      },
      modal: {
        title: 'Sélection de tiers',
        buttons: {
          add: 'Valider',
          close: 'Annuler',
        },
        columns: {
          group: 'Groupe',
          type: 'Type',
          code: 'Code',
          name: 'Nom',
          account: 'N° compte',
          thirdparty: 'Tiers',
          rum: 'RUM',
          reference: 'Référence',
          analysis_note: 'Note Analyse Tiers',
        },
      },
    },
  },
  Analyse: {
    search: {
      state: '- Etat -',
      scope: '- Scope - ',
      company: '- Société -',
      bank: '- Banque -',
      pays: '- Pays -',
      devise: '- Devise -',
      flux: '- Flux - ',
      category: '- Catégorie - ',
    },
    graph: {
      societe: 'Répartition des flux par société',
      banque: 'Répartition des flux par banque',
      type: 'Répartition des flux  par type',
    },
    table: {
      title: 'Analyse Flux',
    },
    onglet: {
      graphe: 'Graphe flux',
      analyse: 'Analyse flux',
    },
  },
}
